"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDebounceInput = require("react-debounce-input");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SearchBox = (0, _styledComponents["default"])(_reactDebounceInput.DebounceInput).attrs(function () {
  return {
    className: "form-control",
    debounceTimeout: 300,
    minLength: 1
  };
}).withConfig({
  displayName: "SearchBox",
  componentId: "sc-15yoq6r-0"
})(["&:focus{background:", ";}&::placeholder{color:", ";opacity:1;font-style:italic;}color:", " !important;"], function (props) {
  return props.theme["focus-color"];
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["black"];
});
var _default = SearchBox;
exports["default"] = _default;